import { useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import useGraphQLClient from '../../../app/hooks/useGraphQLClient';
import AppError from '../../../app/features/error/services/AppError';
import { useAuthContext } from '../../auth/contexts/AuthContext';
import IUserProfile from '../../admin/interfaces/IUserProfile';

const useUserProfiles = () => {
	const graphQLClient = useGraphQLClient();
	const auth = useAuthContext();

	return useQuery<IUserProfile[], Error>(
		['userProfiles'],
		async () => {
			try {
				const data = (await graphQLClient.request(
					gql`
						query {
							investorUsers {
								id
								login
								email
								firstName
								lastName
								isAccountCreated
								isAccountActivated
								importCreationTime
								importDeletionTime
								defaultLanguage
								companies {
									id
									name
									middleOfficeId
									group {
										id
										name
										middleOfficeId
									}
								}
							}
						}
					`,
				)) as { investorUsers: IUserProfile[] };
				return data.investorUsers;
			} catch (e) {
				throw new AppError(e, 'useUserProfiles');
			}
		},
		{
			enabled: auth.authContext === 'employee' && auth.isAuthenticated && !auth.authOverrideUserId,
		},
	);
};

export default useUserProfiles;
